import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { findObjectKeyByValue } from "../../utils/main";
import { createDispatchHook, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { closeModal, openModal } from "../../store/actions/modalAction";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { FlexedColumnBox } from "../../components/layouts/common/boxes";
import { Fragment, memo } from "react";
import moment from "moment";
import { GENDER } from "../../utils/constants";
import { calculateAge } from "../../utils/helper";
import { QrCodeModal } from "./PatientQrCode";
import { ManageAccounts } from "@mui/icons-material";

const DetailsBox = memo(({ title, data = [{ title: "", value: "" }] }) => {
    return (
      <Box>
        <Typography variant="h4" color="primary" mb={5} fontWeight={500}>
          {title}
        </Typography>
        {title == "Personal Details" ? (
          <Grid container spacing={2} flexDirection="row" ml={1}>
            {data.map((item) => (
              <Fragment key={item.title}>
                <Grid container xs={6}>
                  <Grid xs={3}>
                    <Typography variant="h6" color="grey" fontWeight={500}>
                      {item.title}
                    </Typography>
                  </Grid>
                  {/* <Grid xs={1}>
                                  :
                              </Grid> */}
                  <Grid xs={3}>
                    <Typography variant="h6" color="dark" fontWeight={500}>
                      {item.value}
                    </Typography>
                  </Grid>
                  {/* <Typography variant="h6" color="primary" fontWeight={500}></Typography> */}
                </Grid>
                {/* <Grid  item xs={4} >
  
                      </Grid>
                      <Grid  item xs={4} >
                          <Typography variant="h6" color="primary" fontWeight={500}>{item.values}</Typography>
  
                      </Grid> */}
              </Fragment>
            ))}
          </Grid>
        ) : (
          <Grid container xs={12} spacing={2} ml={1}>
            {data.map((item) => (
              <Grid xs={4}>
                <Typography variant="h5" color="grey" fontWeight={500}>
                  {item.title}{" "}
                </Typography>
                <Typography variant="h5" color="dark" fontWeight={500}>
                  {item.value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    );
  });
const PatientInformationView = ({
    loading,
    data,
    onNewFitting,
    title,
    setData,
  }) => {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
 

    return (
      <>
        <CustomDialog
          id={"information"}
          closeText="Close"
          title={"Patient Information"}
          // onEdit={() => {
          //   let route = "/patient-details/" + params.id + "/update";
          //   createDispatchHook(closeModal("information"));
          //   navigate(route);
          // }}
        >
          {/* <TitleBox>
                  <Typography variant="h3" fontWeight={600} >
                      Information
                  </Typography>
                  <Box>
                      <IconButton onClick={onEdit} sx={{ padding: 0, ml: 2 }} >
                          <DriveFileRenameOutlineOutlined fontSize="inherit" color="primary" />
                      </IconButton>
                  </Box>
              </TitleBox> */}
  
          <FlexedColumnBox sx={{ overflowY: "auto" }} p={3} pt={4} pl={7}>
            <DetailsBox
              title="Personal Details"
              data={[
                // {
                //     title: "Patient Id",
                //     value: data?.patient_uid
                // },
                {
                  title: "Full Name",
                  value:
                    data?.name
                  
                },
                {
                  title: "Contact",
                  value: data?.phone ?? "NA",
                },
                {
                  title: "Email",
                  value: data?.email ?? "NA",
                },
                // {
                //   title: "Gender",
                //   value: findObjectKeyByValue(data?.gender, GENDER) ?? "NA",
                // },
                {
                  title: "Date of Birth",
                  value: moment(data?.dob).format("DD / MM / YYYY") ?? "NA",
                },
                {
                  title: "Age",
                  value: data?.age,
                },
  
                // {
                //     title: "Address",
                //     value: data?.address ?? "NA"
                // },
              ]}
            />
  
            <Grid container xs={12} pl={1}>
              <Grid xs={1.5}>
                <Typography variant="h6" color={"grey"} fontWeight={500}>
                  Address{" "}
                </Typography>
              </Grid>
              <Grid xs={10.5}>
                <Typography variant="h6" color="dark" fontWeight={500}>
                  {data.address}
                </Typography>
              </Grid>
            </Grid>
            {/* <Box mt={4}>
              <DetailsBox
                title="Hearing  Details"
                data={[
                  {
                    title: "Level Of Hearing Loss",
                    value: findObjectKeyByValue(
                      data?.level_of_loss,
                      LEVEL_OF_HEARING_LOSS
                    ),
                  },
                  {
                    title: "Type Of Hearing Loss",
                    value: TYPE_OF_HEARING_LOSS_NAMES[data.type_of_loss] ?? "NA",
                  },
                  {
                    title: "Impairment Type",
                    value:
                      findObjectKeyByValue(
                        data?.impairment_type,
                        IMPAIREMENT_TYPE
                      ) ?? "NA",
                  },
                ]}
              />
            </Box> */}
            <Grid container columns={12}>
              <Grid mt={6} xs={4}>
                <Typography variant="h4" color="primary" fontWeight={500}>
                  Application QR Code
                </Typography>
                <QrCodeModal id={data._id} />
              </Grid>
  
              {/* <Grid mt={6} xs={4}>
                <Typography variant="h4" color="primary" fontWeight={500}>
                  Created By{" "}
                </Typography>
                <Box>
                  <Typography variant="h6" color="grey" mb={5} fontWeight={500}>
                    {[data.created_by ? data.created_by.name : "NA"]}
                  </Typography>
                </Box>
              </Grid>
              <Grid mt={6} xs={4}>
                <Typography variant="h4" color="primary" fontWeight={500}>
                  Audiologist{" "}
                </Typography>
                {data?.assigned?.name || (
                  <IconButton
                    sx={{ marginTop: "-12px", color: "red" }}
                    // onClick={() => {
                    //   reassign();
                    // }}
                  >
                    <ManageAccounts />
                  </IconButton>
                )}
              </Grid> */}
            </Grid>
  
            <Grid container columns={12}>
              <Grid container mt={2} xs={6}>
                {/* <QrCodeModal id={data._id} /> */}
              </Grid>
            </Grid>
  
            <Divider />
            <Box mt={5}></Box>
            {/* <DeletePatientButton
              id={data?._id}
              name={data?.first_name + " " + data?.last_name}
            /> */}
          </FlexedColumnBox>
        </CustomDialog>
      </>
    );
  };

  export default PatientInformationView;